import React from 'react'
import Carousel from '../components/Carousel/Carousel'
import Explore from '../components/Explore/Explore'
import client from '../sanityClient'

import image3 from '../assets/carousel/home-carousel-3.webp'
import image5 from '../assets/carousel/home-carousel-5.webp'
import image6 from '../assets/carousel/home-carousel-6.webp'
import image7 from '../assets/carousel/home-carousel-1.webp'

import Calender from '../components/Calender/Calender';

export default function Home(props) {

    const setTitle = props.setTitle;
    const setProgress = props.setProgress;

    React.useEffect(() => {
        setTitle("Academic Outreach and New Initiatives | IIT Delhi")
        setProgress(100);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const [images, setImages] = React.useState([]);

    React.useEffect(() => {
        // Fetch images from the Sanity CMS
        client.fetch(`*[_type == "carouselImage"] | order(position asc){
            "src": image.asset->url,
            position
        }`).then((data) => setImages(data));
    }, []);

    return (
        <>
            <Carousel images={images} title="Welcome to" heading="Academic Outreach@IITD" />
            <Explore />
        </>
    )
}
